<template>
    <v-dialog v-model="internalDialog" max-width="480">
        <v-card>
            <v-card-title class="primary white--text">
                <span class="text-h6">Assign Seat {{ seatLabel }}</span>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pt-6">
                <v-autocomplete v-model="selectedUserId" :items="salesUsers" item-text="name" item-value="id"
                    label="Search for a user" prepend-inner-icon="mdi-account-search" outlined clearable
                    autofocus>
                    <template v-slot:item="{ item }">
                        <v-list-item-avatar size="32">
                            <v-img v-if="item.profile_picture" :src="getProfilePictureUrl(item.profile_picture)"></v-img>
                            <v-avatar v-else color="primary" size="32" class="white--text">{{ initials(item) }}</v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.position_name || item.role?.name }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                </v-autocomplete>
                <v-btn v-if="!currentUserIsHere" text block color="primary" :disabled="saving" @click="addMyself">
                    <v-icon left small>mdi-account-plus</v-icon>
                    Add Myself
                </v-btn>
            </v-card-text>
            <v-card-actions class="pa-4">
                <v-btn v-if="currentUser" text color="error" :disabled="saving" @click="$emit('unassign')">
                    Remove from Seat
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="close">Cancel</v-btn>
                <v-btn color="primary" :loading="saving" :disabled="!selectedUserId" @click="confirm">
                    Assign
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'SeatAssignDialog',
    inject: ['users'],
    props: {
        value: { type: Boolean, default: false },
        seatLabel: { type: String, default: '' },
        currentUser: { type: Object, default: null },
        saving: { type: Boolean, default: false },
    },
    data() {
        return {
            internalDialog: this.value,
            selectedUserId: this.currentUser ? this.currentUser.id : null,
        };
    },
    computed: {
        ...mapGetters({
            get_user: 'auth/get_user',
        }),
        apiUrl() {
            return process.env.VUE_APP_API_URL || '';
        },
        salesUsers() {
            const allowedRoles = ['Sales', 'Admin', 'Super Admin', 'Operations', 'Agent'];
            return (this.users() || []).filter((user) => {
                return user.role_members && user.role_members.some((m) => m.role && allowedRoles.includes(m.role.name));
            });
        },
        currentUserIsHere() {
            return !!(this.currentUser && this.get_user && this.currentUser.id === this.get_user.id);
        },
    },
    watch: {
        value(val) {
            this.internalDialog = val;
            if (val) {
                this.selectedUserId = this.currentUser ? this.currentUser.id : null;
            }
        },
        internalDialog(val) {
            this.$emit('input', val);
        },
    },
    methods: {
        close() {
            this.internalDialog = false;
        },
        confirm() {
            this.$emit('assign', this.selectedUserId);
        },
        addMyself() {
            if (!this.get_user) return;
            this.selectedUserId = this.get_user.id;
            this.$emit('assign', this.selectedUserId);
        },
        initials(user) {
            if (!user || !user.name) return '?';
            const names = user.name.split(' ');
            return names.length >= 2 ? (names[0][0] + names[1][0]).toUpperCase() : user.name.substring(0, 2).toUpperCase();
        },
        getProfilePictureUrl(path) {
            if (!path) return '';
            if (path.startsWith('http://') || path.startsWith('https://')) return path;
            return `${this.apiUrl}/${path}`;
        },
    },
};
</script>
